import React from "react";

/**
 * Componente del icono de Agencia (edificios con personas)
 * Representa una agencia o grupo de trabajo
 * @param {number} size - Tamaño del icono en píxeles
 * @param {string} color - Color del icono (por defecto "black")
 * @param {object} props - Props adicionales para el SVG
 */
export const AgencyIcon = ({ size = 24, color = "black", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Edificio izquierdo */}
        <path
            d="M 2.5 10 L 8 8.5 L 8 18 L 2.5 18 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="miter"
        />

        {/* Línea edificio izquierdo */}
        <line x1="4.2" y1="11.5" x2="6.3" y2="11.5" stroke={color} strokeWidth="0.7" strokeLinecap="round" />

        {/* Edificio central */}
        <path
            d="M 8.5 5 L 15.5 5 L 15.5 18 L 8.5 18 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="miter"
        />

        {/* Líneas edificio central - eliminadas las últimas para dar espacio a la cabeza */}
        <line x1="10.2" y1="7" x2="13.8" y2="7" stroke={color} strokeWidth="0.7" strokeLinecap="round" />
        <line x1="10.2" y1="8.5" x2="13.8" y2="8.5" stroke={color} strokeWidth="0.7" strokeLinecap="round" />
        <line x1="10.2" y1="10" x2="13.8" y2="10" stroke={color} strokeWidth="0.7" strokeLinecap="round" />
        <line x1="10.2" y1="11.5" x2="13.8" y2="11.5" stroke={color} strokeWidth="0.7" strokeLinecap="round" />

        {/* Edificio derecho */}
        <path
            d="M 16 8.5 L 21.5 10 L 21.5 18 L 16 18 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="miter"
        />

        {/* Línea edificio derecho */}
        <line x1="17.7" y1="11.5" x2="19.8" y2="11.5" stroke={color} strokeWidth="0.7" strokeLinecap="round" />

        {/* Persona izquierda - cabeza más grande */}
        <circle
            cx="5.25"
            cy="15.5"
            r="1.8"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
        />
        <path
            d="M 1.75 18.5 C 1.75 17.8, 3 17.2, 5.25 17.2 C 7.5 17.2, 8.75 17.8, 8.75 18.5 L 8.75 21.5 C 8.75 22, 8.35 22.3, 7.85 22.3 L 2.65 22.3 C 2.15 22.3, 1.75 22, 1.75 21.5 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="round"
        />

        {/* Persona derecha - cabeza más grande */}
        <circle
            cx="18.75"
            cy="15.5"
            r="1.8"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
        />
        <path
            d="M 15.25 18.5 C 15.25 17.8, 16.5 17.2, 18.75 17.2 C 21 17.2, 22.25 17.8, 22.25 18.5 L 22.25 21.5 C 22.25 22, 21.85 22.3, 21.35 22.3 L 16.15 22.3 C 15.65 22.3, 15.25 22, 15.25 21.5 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="round"
        />

        {/* Persona central - cabeza más grande */}
        <circle
            cx="12"
            cy="15.5"
            r="1.8"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
        />
        <path
            d="M 8.5 18.5 C 8.5 17.8, 9.75 17.2, 12 17.2 C 14.25 17.2, 15.5 17.8, 15.5 18.5 L 15.5 21.5 C 15.5 22, 15 22.3, 14.4 22.3 L 9.6 22.3 C 9 22.3, 8.5 22, 8.5 21.5 Z"
            fill="white"
            stroke={color}
            strokeWidth="0.9"
            strokeLinejoin="round"
        />
    </svg>
);
